import { Countries } from "assets/data";
import { Combines } from "helpers";
import React from "react";
import { GuestParamType, ShareParamType, StringOrOptionType, ValidationType } from "types";
import { Constants, Routes, Secrets } from "utils";

export const getImage = (src: string) => Constants.BASE_URL + `/images/${src}`;
export const getUserAvatar = (id: string) => Constants.S3.ENDPOINT + "/" + Constants.S3.BUCKET_NAME + `/avatars/${id}.png`;

export type StepComponentProps<T = any> = {
  data: T;
  updateData: (path: string, data: Partial<T>) => void;
};

export type ValidateFunction<T = any> = (data: T) => ValidationType<T>;

export type StepComponentRef<T = any> = {
  validate?: <T>() => ValidationType<T> | Promise<ValidationType<T>>;
};

export type StepComponent<T = any> = React.ForwardRefExoticComponent<
  React.PropsWithoutRef<StepComponentProps> &
  React.RefAttributes<StepComponentRef<T>>
>;

export function createStep<T = any>(
  Component: React.ForwardRefExoticComponent<
    React.PropsWithoutRef<StepComponentProps> &
    React.RefAttributes<StepComponentRef<T>>
  >,
  options?: { skippable?: boolean }
) {
  return {
    Component,
    skippable: options?.skippable ?? false,
  };
}

export const createBranchStep = <T>(
  Component: React.ForwardRefExoticComponent<
    React.PropsWithoutRef<StepComponentProps> &
    React.RefAttributes<StepComponentRef<T>>
  >,
  options?: { onBranch?: (pushFlow: Function) => void }
) => ({
  Component,
  onBranch: options?.onBranch,
});


export const countries = Object.keys(Countries).map((country: string) => country) as StringOrOptionType[];
export const cities = (country: string) => Countries[country].map((city: string) => city) as StringOrOptionType[];

export const generateInterpolatedUrl = (route: string) => [Constants.BASE_URL, route].join("");

export const encodedUrl = <T>(url: string, payload: T) => Combines.interpolateURL(url, { token: Secrets.encrypt<T>(payload) });
export const decodeUrl = (token: string) => Secrets.decrypt(token);

export const generateShareUrl = (payload: ShareParamType) => encodedUrl<ShareParamType>([Constants.BASE_URL, Routes.contribute].join(""), payload);
export const generateRecoverAccountUrl = (payload: GuestParamType) => encodedUrl<GuestParamType>([Constants.BASE_URL, Routes.guest].join(""), payload);
export const generateForgotPasswordUrl = (payload: GuestParamType) => encodedUrl<GuestParamType>([Constants.BASE_URL, Routes.resetpassword].join(""), payload);
